exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".accord-main .accord-one-header a.accord-title {\n    font-weight: bold;\n    color: #f39c10;\n}\n\n.accord-main .accord-one-header a.accord-status {\n    font-weight: bold;\n    color: #AAA;\n}\n\n.accord-main .accord-one-header select {\n    padding: 0;\n    height: auto;\n    width: auto;\n}\n\n.accord-main .accord-one-header {\n    padding: 8px 16px;\n    border: 1px solid rgba(0,0,0,0.125);\n    border-top: 4px solid #BBB;\n    border-top-left-radius: 2px;\n    border-top-right-radius: 2px;\n    font-size: 16px;\n}\n\n.accord-main .accord-one-content {\n    padding: 8px 16px;\n    border: 1px solid rgba(0,0,0,0.125);\n    border-top: none;\n}\n\n.accord-main .accord-one-header .accord-head-right {\n    position: relative;\n    float: right;\n}\n\n.accord-main {\n\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/accounting/processing/processing.css
// module id = 1217
// module chunks = 9